import { render, staticRenderFns } from "./ModalCompleteGenericPublish.vue?vue&type=template&id=6566c350&scoped=true&"
import script from "./ModalCompleteGenericPublish.vue?vue&type=script&lang=js&"
export * from "./ModalCompleteGenericPublish.vue?vue&type=script&lang=js&"
import style0 from "./ModalCompleteGenericPublish.vue?vue&type=style&index=0&id=6566c350&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6566c350",
  null
  
)

export default component.exports